/**
 *
 * Created Date: 2019-03-27, 19:54:45 (zhenliang.sun)
 * Last Modified: 2019-08-14, 14:34:41 (zhenliang.sun)
 * Email: zhenliang.sun@gmail.com
 *
 * Distributed under the MIT license. See LICENSE file for details.
 * Copyright (c) 2019 vhall
 */
import { fabric } from 'fabric';
import UndoManager from '../manager/UndoManager';
import { GraphName, GraphType } from './../constants/Constants';
import CanvasTriangleBase from './CanvasTriangleBase';

/**
 * 等腰三角形
 *
 * @export
 * @class CanvasIsoscelesTriangle
 * @extends {CanvasTriangleBase}
 * @author zhenliang.sun
 */
export default class CanvasIsoscelesTriangle extends CanvasTriangleBase {
  constructor(app) {
    super(app);
  }

  _mouseDownHandler(o) {
    super._mouseDownHandler(o);

    let sp = this.root.getPointer(o.e);

    this._triangle = new fabric[GraphName.TRIANGLE]({
      left: this.ox,
      top: this.oy,
      width: sp.x - this.ox,
      height: sp.y - this.oy,
      objectCaching: false,
      stroke: this._option.stroke,
      strokeWidth: this._option.strokeWidth,
      strokeLineJoin: 'round',
      strokeLineCap: 'round',
      fill: null,
      selectable: false
    });

    this.root.add(this._triangle);
    this.stage.renderNow();
  }

  _mouseMoveHandler(o) {
    super._mouseMoveHandler(o);
    if (!this._isMouseDown) {
      return;
    }

    let sp = this.root.getPointer(o.e);
    this._triangle.set({
      width: sp.x - this.ox,
      height: sp.y - this.oy
    });

    this.stage.renderNow();
  }
  _mouseUpHandler(o) {
    super._mouseUpHandler(o);
    this._isMouseDown = false;
    this._triangle.setCoords();
    this.stage.renderNow();

    let data = this.factory.createAddData(this._triangle);
    // MsgSender.add(data)
    this.app.sender.add(data);

    let allData = this.root.toDatalessJSON();
    UndoManager.getInstance().save(allData);
  }

  static toAddData(target) {
    let obj = CanvasTriangleBase.toAddData(target);
    obj.gtype = GraphType.ISOSCELES_TRIANGLE;
    return obj;
  }
}
